import { isDesktop } from './platform';

let baseIcon: HTMLImageElement | null = null;
let lastKey = '';

/**
 * Shows mentions like Discord: a red number on the tab icon (web) or the app icon (desktop),
 * or a small dot when there are only unread messages.
 */
export function setAppBadge(mentions: number, unread: boolean): void {
  const key = `${mentions}:${unread}`;
  if (key === lastKey) return;
  lastKey = key;
  if (isDesktop) {
    void import('@tauri-apps/api/window')
      .then(({ getCurrentWindow }) =>
        getCurrentWindow().setBadgeCount(mentions > 0 ? mentions : undefined),
      )
      .catch(() => undefined);
    return;
  }
  drawFavicon(mentions, unread);
}

function drawFavicon(mentions: number, unread: boolean): void {
  const link =
    document.querySelector<HTMLLinkElement>('link[rel~="icon"]') ??
    Object.assign(document.head.appendChild(document.createElement('link')), { rel: 'icon' });
  baseIcon ??= Object.assign(new Image(), { src: '/favicon.svg' });
  const paint = () => {
    const size = 64;
    const canvas = Object.assign(document.createElement('canvas'), { width: size, height: size });
    const ctx = canvas.getContext('2d');
    if (!ctx || !baseIcon) return;
    ctx.drawImage(baseIcon, 0, 0, size, size);
    if (mentions > 0 || unread) {
      const r = mentions > 0 ? 18 : 10;
      ctx.beginPath();
      ctx.arc(size - r, size - r, r, 0, Math.PI * 2);
      ctx.fillStyle = mentions > 0 ? '#e5484d' : '#ffffff';
      ctx.fill();
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#1f2430';
      ctx.stroke();
      if (mentions > 0) {
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 24px system-ui, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(mentions > 9 ? '9+' : String(mentions), size - r, size - r + 1);
      }
    }
    link.href = canvas.toDataURL('image/png');
    link.type = 'image/png';
  };
  if (baseIcon.complete) paint();
  else baseIcon.onload = paint;
}
